<div class="modal-container-content">
  <span>Als je een account hebt ontvang je spoedig een e-mail met instructies om je wachtwoord opnieuw in te stellen.</span>
</div>

<div class="modal-container-footer">
  <app-button (click)="close()">Terug naar login</app-button>
</div>
